import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import FlexTable from '../table/FlexTable';
import IndexRow from '../../containers/table/IndexRow';
import HeaderComponent from '../HeaderComponent';
import table from '../../styles/table/flextable';

class Indices extends React.Component {
    static propTypes = {
        breakpoint: PropTypes.string,
        indices: PropTypes.array,
        t: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = ({
            expanded: props.indices[0],
            indices: props.indices,
        });

        this._expand = this._expand.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.indices
            && nextProps.indices.length > 0
            && nextProps.indices[0] !== this.props.indices[0]
        ) {
            this.setState({
                expanded: nextProps.indices[0],
                indices: nextProps.indices,
            });
        }
    }

    _expand(id) {
        const symbol = this.state.expanded === id ? '' : id;
        this.setState({ expanded: symbol });
    }

    render() {
        let tableHeadings;
        if (this.props.breakpoint === 'mobile-small') {
            tableHeadings = [
                '',
                'LAST',
                'CHANGE_PCT',
            ];
        } else {
            tableHeadings = [
                '',
                'LAST',
                'CHANGE',
                'CHANGE_PCT',
            ];
        }
        const { t } = this.props;

        return (
            <HeaderComponent title={t('indices')} link="/index">
                <FlexTable
                    className={table.padded}
                    columns={tableHeadings}
                    expectedHeight={361}
                >
                    {this.state.indices.map(index => (
                        <IndexRow
                            symbol={index}
                            key={index}
                            expand={this.state.expanded === index}
                            onClick={this._expand}
                            columns={tableHeadings.length}
                        />
                    ))}
                </FlexTable>
            </HeaderComponent>
        );
    }
}

export default translate()(Indices);



/** WEBPACK FOOTER **
 ** /src/shared/components/front/Indices.js
 **/